import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { formatterDate } from "../../../utils"
import { GetAllInspectionVisit } from "../../incarichi/slice"


export function PcDetailsInc() {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const assignmentState = useAppSelector(state => state.assignment)

    useEffect(() => {
        dispatch(GetAllInspectionVisit({
            itemsPerPage: 0,
            page: 0,
            assignmentId: assignmentState.assignmentSelected
        }))
    }, [])

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Amministrazione', 'Gestione Personale - Contabile']}
            noPaddingLat
            headerLabel="Gestione Personale - Contabile"
            headerIcon={
                <button style={{ paddingTop: '12px' }} onClick={() => {
                    navigate('/personaleContabile')
                }}>
                    <ArrowLeftIcon />
                </button>
            }
        >
            <div className="p-6 flex flex-col gap-6">
                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl"></th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Verifica Amministrativa</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Dettaglio</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. cliente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Attivita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Visita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prelievo</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Modalita Visita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Dettagli Visita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Espletata</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Stato</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Verifica Amministrativa</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Verifica Visita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Costo Visita</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assignmentState.getAllInspectionVisitResponse?.data.map((iv, index) => (
                                <tr
                                    key={index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{assignmentState.getAssignmentByIdResponse?.departureProtocolHeadQuarter}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{iv.customerCompanyName}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{iv.customerClientCode}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(iv.effectiveVisitDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">prot contr</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">ver amm</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">costo</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">stato</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="flex flex-col gap-3">
                    <h2 className="text-brandPrimary-900 font-semibold text-base">Riepilogo parziale per l'incarico</h2>
                    <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                        <table className="w-full border-collapse text-sm">
                            <thead>
                                <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Numero Visite</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Parziale Rimborso Km</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Parziale Rimborso Alloggio</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Parziale Rimborso Vitto</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Parziale Rimborso Altre Spese</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Totale Parziale Rimborsi</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Parziale Rimborso Visite</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignmentState.getAllInspectionVisitResponse?.data.map((iv, index) => (
                                    <tr
                                        key={index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="flex flex-col gap-3">
                    <h2 className="text-brandPrimary-900 font-semibold text-base">Previsione costi per l'incarico</h2>
                    <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                        <table className="w-full border-collapse text-sm">
                            <thead>
                                <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Numero Visite</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Totale Rimborso Km</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Totale Rimborso Alloggio</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Totale Rimborso Vitto</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Totale Rimborso Altre Spese</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Totale Rimborsi</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Totale Rimborso Visite</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignmentState.getAllInspectionVisitResponse?.data.map((iv, index) => (
                                    <tr
                                        key={index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="flex flex-col gap-3">
                    <h2 className="text-brandPrimary-900 font-semibold text-base">Valida Note Proforma</h2>
                    <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                        <table className="w-full border-collapse text-sm">
                            <thead>
                                <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Data Proforma</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Visualizza</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Validata (si/no)</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Invia Validazione</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Annulla Validazione</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignmentState.getAllInspectionVisitResponse?.data.map((iv, index) => (
                                    <tr
                                        key={index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="flex flex-col gap-3">
                    <h2 className="text-brandPrimary-900 font-semibold text-base">Visualizza note proforma create per le visite ispettive</h2>
                    <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                        <table className="w-full border-collapse text-sm">
                            <thead>
                                <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Data Visita</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Visualizza</th>
                                    <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Data</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignmentState.getAllInspectionVisitResponse?.data.map((iv, index) => (
                                    <tr
                                        key={index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap"></td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{assignmentState.getAssignmentByIdResponse?.departureProtocolHeadQuarter}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{iv.customerCompanyName}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{iv.customerClientCode}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </Layout>
    )
}